<div class="page-err">
  <div class="err-container text-center">
    <div class="err">
      <h1>404</h1>
      <h2>Sorry, page not found</h2>
    </div>

    <div class="err-body">
      <a mat-raised-button href="/" class="btn-lg">Go Back to Home Page</a>
    </div>
  </div>
</div>
